<div class="lnb-header">
  <div class="lnb-header-text">
    <h1>Log Breakdown</h1>
    <div class="incident-number">
      Incident #: {{incident.incidentNumber || 'Loading...'}}
    </div>
  </div>
  <div class="lnb-header-actions">
    <button nz-button nzType="text" nzSize="large" (click)="onSubscribeToBreakdownUpdates()" class="header-refresh-btn">
      <nz-icon nzType="whats-app" nzTheme="outline" /> Subscribe
    </button>
    <button nz-button nzType="text" nzSize="large" (click)="onRefresh()" [nzLoading]="isLoading" class="header-refresh-btn">
      <nz-icon nzType="reload" nzTheme="outline" /> Refresh
    </button>
  </div>
</div>

<div class="mobile-container">
  <nz-spin [nzSpinning]="isLoading || isSubmitting">
    <!-- Photos Card -->
    <div class="form-section">
      @if (fleetChatAvailable) {
        <app-incident-chat class="chat-action" [incidentId]="currentIncidentId" [incidentNumber]="incident.incidentId === currentIncidentId ? incident.incidentNumber : ''"
          [senderType]="chatSender" [refreshKey]="incident" [notificationsEnabled]="true" (fleetChatUnavailable)="disableFleetChat()" />
      }
      <button nz-button nzType="default" nzSize="large" nzBlock (click)="onViewImages()">
        <i nz-icon nzType="file-image" nzTheme="outline"></i>
        Add / View Images ({{ getImageCount() }})
      </button>
      @if (hasPendingImages()) {
        <nz-alert nzType="warning" [nzMessage]="pendingImages.length + ' photo(s) pending upload. They will sync automatically when online.'" nzShowIcon style="margin-top: 12px;"></nz-alert>
      }
    </div>

    <!-- Breakdown Details Section (collapsible, default open) -->
    <nz-collapse>
      <nz-collapse-panel [nzHeader]="breakdownDetailsHeader" [nzActive]="true">
        <ng-template #breakdownDetailsHeader>
          <div class="breakdown-details-header">
            <span>Breakdown Details</span>
            <span class="required-progress">{{ incident.populatedMinimumRequiredFieldsText }}</span>
          </div>
        </ng-template>
        <form nz-form>
        <nz-form-item>
          <nz-form-label nzFor="transporterName">Transporter</nz-form-label>
          <nz-form-control [appValidationBorder]="transporterName">
            <input
              nz-input
              id="transporterName"
              name="transporterName"
              placeholder="Enter transporter name"
              [ngModel]="transporterName"
              (ngModelChange)="onTransporterInput($event)"
              [nzAutocomplete]="transporterAuto"
              type="text" />
            <nz-autocomplete #transporterAuto>
              @for (name of filteredTransporters; track name) {
                <nz-auto-option [nzValue]="name">{{ name }}</nz-auto-option>
              }
            </nz-autocomplete>
          </nz-form-control>
        </nz-form-item>
          <nz-form-item>
          <nz-form-label nzFor="vehicleReg">Vehicle</nz-form-label>
          <nz-form-control [appValidationBorder]="vehicleReg">
            <input 
              nz-input 
              id="vehicleReg" 
              name="vehicleReg" 
              placeholder="Registration or Fleet Number" 
              [(ngModel)]="vehicleReg"
              (input)="onVehicleRegInput($event)"
              type="text" />
          </nz-form-control>
        </nz-form-item>
                <nz-form-item>
          <nz-form-label nzFor="tyreSize">Tyre Size</nz-form-label>
          <nz-form-control [appValidationBorder]="tyreSize">
            <nz-select 
              nzShowSearch 
              nzPlaceHolder="Select Tyre Size"
              id="tyreSize" 
              name="tyreSize" 
              [ngModel]="tyreSize"
              (ngModelChange)="onTyreSizeChange($event)">
              @for (item of sharedDataService.tyreSizes; track $index) {
                <nz-option [nzValue]="item.gencode" [nzLabel]="item.size"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>


          <nz-form-item>
          <nz-form-label nzFor="tyrePosition">Tyre Position</nz-form-label>
          <nz-form-control [nzSpan]="18" [appValidationBorder]="hasSelectedTyreLocation()">
            <div nz-row [nzGutter]="[8, 8]">
                <div nz-col [nzSpan]="8">
                    <button nz-button nzBlock [nzSize]="'default'" 
                        [nzType]="hasTyreInLocation(tyreLocation.steer) ? 'primary' : 'default'" 
                        (click)="onClickTyreLocation(tyreLocation.steer)">
                        <nz-icon nzType="car" nzTheme="outline" /> Steer
                    </button>
                </div>
                <div nz-col [nzSpan]="8">
                    <button nz-button nzBlock [nzSize]="'default'" 
                        [nzType]="hasTyreInLocation(tyreLocation.drive) ? 'primary' : 'default'" 
                        (click)="onClickTyreLocation(tyreLocation.drive)">
                        <nz-icon nzType="build" nzTheme="outline" /> Drive
                    </button>
                </div>
                <div nz-col [nzSpan]="8">
                    <button nz-button nzBlock [nzSize]="'default'" 
                        [nzType]="hasTyreInLocation(tyreLocation.trailer) ? 'primary' : 'default'" 
                        (click)="onClickTyreLocation(tyreLocation.trailer)">
                        <nz-icon nzType="block" nzTheme="outline" /> Trailer
                    </button>
                </div>
            </div>
        </nz-form-control>
          </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="tyreType">Tyre Type</nz-form-label>
          <nz-form-control [appValidationBorder]="hasSelectedTyreType()">
            <nz-space-compact>
              <button nz-button [nzType]="isTyreTypeSelected(-1) ? 'primary' : 'default'" (click)="onSelectTyreType(-1)">Import</button>
              <button nz-button [nzType]="isTyreTypeSelected(-2) ? 'primary' : 'default'" (click)="onSelectTyreType(-2)">Retread</button>
              <button nz-button [nzType]="isTyreTypeSelected(-4) ? 'primary' : 'default'" (click)="onSelectTyreType(-4)">Local</button>
              <button nz-button [nzType]="isTyreTypeSelected(-3) ? 'primary' : 'default'" (click)="onSelectTyreType(-3)">Any</button>
              <button nz-button [nzType]="isTyreTypeSelected(-5) ? 'primary' : 'default'" (click)="onSelectTyreType(-5)">Spare</button>
              <button nz-button [nzType]="isTyreTypeSelected(-6) ? 'primary' : 'default'" (click)="onSelectTyreType(-6)">Own Stock</button>
            </nz-space-compact>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="driverName">Driver Name</nz-form-label>
          <nz-form-control [appValidationBorder]="driverName" [validationBorderRequired]="false">
            <input 
              nz-input 
              id="driverName" 
              name="driverName" 
              placeholder="Enter driver name" 
              [(ngModel)]="driverName"
              type="text" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="driverCell">Driver Cell</nz-form-label>
          <nz-form-control [appValidationBorder]="driverCell">
            <input 
              nz-input 
              id="driverCell" 
              name="driverCell" 
              placeholder="Enter driver cell number" 
              [(ngModel)]="driverCell"
              (input)="onDriverCellInput($event)"
              (blur)="onDriverCellBlur()"
              type="tel" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="description">Description</nz-form-label>
          <nz-form-control [appValidationBorder]="description">
            <textarea 
              nz-input 
              id="description" 
              name="description" 
              placeholder="Enter breakdown description" 
              [ngModel]="description"
              (ngModelChange)="onDescriptionChange($event)"
              [nzAutosize]="{ minRows: 3, maxRows: 24 }"
              ></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="orderNumber">Reference Number</nz-form-label>
          <nz-form-control [appValidationBorder]="orderNumber">
            <input 
              nz-input 
              id="orderNumber" 
              name="orderNumber" 
              placeholder="Enter reference number" 
              [ngModel]="orderNumber"
              (ngModelChange)="onOrderNumberChange($event)"
              type="text" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="callcentreOperator">Handled By</nz-form-label>
          <nz-form-control>
            <nz-select
              id="callcentreOperator"
              name="callcentreOperator"
              nzShowSearch
              nzAllowClear
              [(ngModel)]="incident.callcentreOperatorId">
              @for (operator of incident.availableCallcentreOperators; track operator.userId) {
                <nz-option [nzValue]="operator.userId" [nzLabel]="operator.fullName"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </form>
      </nz-collapse-panel>
    </nz-collapse>

    <!-- Timeline Section (collapsible, default open) -->
    @if (incident && incident.incidentId) {
    <nz-collapse>
      <nz-collapse-panel nzHeader="Timeline" [nzActive]="true">
        <div class="timeline-table">
          <div class="timeline-row" [class.done]="incident.dtLogged">
            <span class="timeline-label">Logged</span>
            <span class="timeline-value">{{ incident.dtLogged ? ((incident.dtLogged + 'Z') | date:'HH:mm') : '' }}</span>
          </div>
          <div class="timeline-row" [class.done]="incident.incidentActions?.dtSPAssigned">
            <span class="timeline-label">Provider Allocated</span>
            <span class="timeline-value">{{ incident.incidentActions?.dtSPAssigned ? ((incident.incidentActions!.dtSPAssigned + 'Z') | date:'HH:mm') : '' }}</span>
          </div>
          <div class="timeline-row" [class.done]="incident.incidentActions?.dtTechAssigned">
            <span class="timeline-label">Technician Accepted</span>
            <span class="timeline-value">{{ incident.incidentActions?.dtTechAssigned ? ((incident.incidentActions!.dtTechAssigned + 'Z') | date:'HH:mm') : '' }}</span>
          </div>
          <div class="timeline-row" [class.done]="incident.incidentActions?.dtTechConfirmedEta">
            <span class="timeline-label">ETA Confirmed</span>
            <span class="timeline-value">{{ incident.incidentActions?.dtTechConfirmedEta ? ((incident.incidentActions!.dtTechConfirmedEta + 'Z') | date:'HH:mm') : '' }}</span>
          </div>
          @if (incident.incidentActions?.dtTechConfirmedEta) {
            <div class="timeline-row" [class.done]="incident.breakdownTechnicianDriverEta">
              <span class="timeline-label">ETA</span>
              <span class="timeline-value">
                @if (incident.breakdownTechnicianDriverEta) {
                  {{ (incident.breakdownTechnicianDriverEta + 'Z') | date:'HH:mm' }}
                  <span class="eta-time-badge">{{ etaMinutesRemaining }} min</span>
                }
              </span>
            </div>
          }
          @if (incident.incidentActions?.dtTechDelayAdded) {
            <div class="timeline-row" [class.done]="incident.incidentActions?.dtTechDelayAdded">
              <span class="timeline-label">Delay Added</span>
              <span class="timeline-value">{{ incident.incidentActions?.dtTechDelayAdded ? ((incident.incidentActions!.dtTechDelayAdded + 'Z') | date:'HH:mm') : '' }}</span>
            </div>
            @for (delay of incident.incidentDelays; track $index) {
              <div class="timeline-row done timeline-row-delay">
                <span class="timeline-label timeline-label-sub">+{{ delay.delayMinutes }} min</span>
                <span class="timeline-value timeline-value-sub">{{ delay.delayReason }}</span>
              </div>
            }
          }
          <div class="timeline-row" [class.done]="incident.incidentActions?.dtTechArrived">
            <span class="timeline-label">Technician Arrived</span>
            <span class="timeline-value">{{ incident.incidentActions?.dtTechArrived ? ((incident.incidentActions!.dtTechArrived + 'Z') | date:'HH:mm') : '' }}</span>
          </div>
          <div class="timeline-row" [class.done]="incident.incidentActions?.dtCompleted">
            <span class="timeline-label">Technician Completed</span>
            <span class="timeline-value">{{ incident.incidentActions?.dtCompleted ? ((incident.incidentActions!.dtCompleted + 'Z') | date:'HH:mm') : '' }}</span>
          </div>
        </div>
      </nz-collapse-panel>
    </nz-collapse>
    }

    <!-- Location Section (collapsible, default closed) -->
    <nz-collapse>
      <nz-collapse-panel nzHeader="Location" [nzActive]="false">
        <div class="map-section">
          <div class="map-wrapper">
            @if (mapUrl) {
              <iframe
                [src]="mapUrl"
                width="100%"
                height="100%"
                style="border:0; display:block;"
                allowfullscreen=""
                loading="lazy">
              </iframe>
            }
          </div>
          <div class="location-description">
            @if (incident.location.description) {
              <nz-tag [nzColor]="'blue'">
                <i nz-icon nzType="environment" nzTheme="outline"></i>
                {{ incident.location.description }}
              </nz-tag>
            }
          </div>
        </div>
      </nz-collapse-panel>
    </nz-collapse>

    <!-- Submit Button -->
    <div class="button-section">
      <button 
        nz-button 
        nzType="primary" 
        nzSize="large" 
        nzBlock
        (click)="onSubmit()"
        [nzLoading]="isSubmitting">
        <i nz-icon nzType="check-circle" nzTheme="outline"></i>
        Update Breakdown
      </button>
    </div>
  </nz-spin>
</div>

<nz-modal
  [(nzVisible)]="isViewImagesModalVisible"
  nzTitle="Photos"
  (nzOnCancel)="isViewImagesModalVisible = false"
  nzWidth="95%"
  [nzFooter]="null">
  <ng-container *nzModalContent>
    <nz-collapse>
    @for (cat of imageCategories; track cat.categoryId) {
      <nz-collapse-panel [nzHeader]="nzCollapsePanelHeader">
        <ng-template #nzCollapsePanelHeader>
          {{ cat.categoryName }} ({{ getCategoryImages(cat.categoryId).length }})
          @if (getPendingImagesByCategory(cat.categoryId).length > 0) {
            <nz-tag nzColor="orange" style="margin-left: 8px;">
              {{ getPendingImagesByCategory(cat.categoryId).length }} Pending
            </nz-tag>
          }
        </ng-template>
        <div class="modal-photo-buttons">
          <button nz-button nzType="default" nzSize="large" (click)="galleryInput.click()">
            <i nz-icon nzType="picture" nzTheme="outline"></i> Select Images
          </button>
          <button nz-button nzType="default" nzSize="large" (click)="cameraInput.click()">
            <i nz-icon nzType="camera" nzTheme="outline"></i> Take Photo
          </button>
          <input #galleryInput type="file" accept="image/*" multiple (change)="onGallerySelect($event, cat)" style="display: none;" />
          <input #cameraInput type="file" accept="image/*" capture="environment" (change)="onCameraCapture($event, cat)" style="display: none;" />
        </div>
        @for (doc of getCategoryImages(cat.categoryId); track doc.documentId) {
          <div class="modal-image-card">
            <div class="image-card-image-wrapper">
              <img [src]="doc.localBase64 || doc.url" [alt]="doc.description" />
              <button class="image-delete-btn" nz-button nzType="default" [nzLoading]="removingDocumentId === doc.documentId" nzDanger nzShape="circle" (click)="onRemoveUploadedImage(doc.documentId)">
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </button>
            </div>
            @if (doc.description) {
              <div class="image-card-footer"><span>{{ doc.description }}</span></div>
            }
          </div>
        }
        @if (getPendingImagesByCategory(cat.categoryId).length > 0) {
          <h4 class="pending-images-header">Pending Upload ({{ getPendingImagesByCategory(cat.categoryId).length }})</h4>
          @for (img of getPendingImagesByCategory(cat.categoryId); track img.id) {
            <div class="modal-image-card pending-image-card">
              <div class="image-card-image-wrapper">
                <img [src]="img.fileBase64" [alt]="img.name" />
                <button class="image-delete-btn" nz-button nzType="default" [nzLoading]="removingDocumentId === img.id" nzDanger nzShape="circle" (click)="onRemovePendingImage(img.id!)">
                  <i nz-icon nzType="delete" nzTheme="outline"></i>
                </button>
                <nz-tag class="image-status-tag" [nzColor]="img.status === 'failed' ? 'red' : 'orange'">
                  {{ img.status === 'failed' ? 'Failed' : 'Pending' }}
                </nz-tag>
              </div>
            </div>
          }
        }
      </nz-collapse-panel>
    }
    </nz-collapse>
  </ng-container>
</nz-modal>
